(function () {
  'use strict';

  var SELECTOR = 'variant-selection';
  var BOUND_ATTR = 'data-variant-hooks-bound';

  // Hide unavailable options by configuring OptionsSelection
  function configureOptionsSelectionFor(vsEl) {
    try {
      if (!vsEl) return;
      var formEl = (vsEl.closest && vsEl.closest('[data-product-form]')) || null;
      var scope = formEl || (vsEl.closest && vsEl.closest('.product-template, .quickshop-template')) || vsEl;
      var requiresManual = !!(formEl && formEl.getAttribute && formEl.getAttribute('data-require-selection') === 'true');
      var opts = scope.querySelectorAll ? scope.querySelectorAll('options-selection') : [];
      for (var i = 0; i < opts.length; i++) {
        var os = opts[i];
        if (!os.hasAttribute('remove-unavailable')) os.setAttribute('remove-unavailable', '');
        if (!os.hasAttribute('disable-unavailable')) os.setAttribute('disable-unavailable', '');
        
        // Check if theme has auto-select disabled globally
        var themeAutoSelectDisabled = false;
        try {
          if (window.PXUTheme && window.PXUTheme.theme_settings) {
            themeAutoSelectDisabled = window.PXUTheme.theme_settings.select_first_available_variant === false;
          }
        } catch (e) { /* noop */ }
        
        // Respect theme: remove auto-select when manual gating is required OR when theme setting is disabled
        if (requiresManual || themeAutoSelectDisabled) {
          if (os.hasAttribute('select-first-available')) os.removeAttribute('select-first-available');
        }
        // Bind change hook once to prune after theme updates the list
        if (!os.__pruneBound) {
          os.addEventListener('change', function (evt) {
            var targetOs = evt.currentTarget;
            setTimeout(function () { 
              pruneUnavailableOptions(targetOs);
              manageDependentSelectors(targetOs.closest ? targetOs.closest('variant-selection') || document : document);
            }, 0);
          });
          os.__pruneBound = true;
        }
        
      }
      // Initial prune
      pruneUnavailableOptions(scope);
      // Initial dependent selectors management
      manageDependentSelectors(scope);
      // Also apply pruning after a short delay to ensure theme has processed options
      setTimeout(function() {
        pruneUnavailableOptions(scope);
        manageDependentSelectors(scope);
      }, 200);
    } catch (e) { /* noop */ }
  }





  // Remove/hide unavailable values (available=false) in selects and radios/swatches
  function pruneUnavailableOptions(root) {
    try {
      var scope = root && root.querySelectorAll ? root : document;
      var allOptionContainers = (scope.querySelectorAll ? scope.querySelectorAll('options-selection [data-variant-option]') : []);
      for (var i = 0; i < allOptionContainers.length; i++) {
        var container = allOptionContainers[i];
        // Remove unavailable option values
        var vals = container.querySelectorAll('[data-variant-option-value]');
        var removedSelected = false;
        for (var j = 0; j < vals.length; j++) {
          var valEl = vals[j];
          if (valEl && valEl.dataset && valEl.dataset.variantOptionAvailable === 'false') {
            if ((valEl.selected && typeof valEl.selected === 'boolean') || (valEl.checked && typeof valEl.checked === 'boolean')) {
              removedSelected = true;
            }
            var wrapper = valEl.closest && valEl.closest('[data-variant-option-value-wrapper]');
            var nodeToRemove = wrapper || valEl;
            if (nodeToRemove && nodeToRemove.parentNode) nodeToRemove.parentNode.removeChild(nodeToRemove);
          }
        }
        // If we removed the selected value from a select, optionally select the first available based on theme setting
        var selectEl = container.matches('select[data-variant-option]') ? container : container.querySelector('select[data-variant-option]');
        if (selectEl) {
          var formEl = selectEl.closest && selectEl.closest('[data-product-form]');
          var requiresManual = !!(formEl && formEl.getAttribute && formEl.getAttribute('data-require-selection') === 'true');
          var osRoot = selectEl.closest && selectEl.closest('options-selection');
          var themeWantsAuto = !!(osRoot && osRoot.hasAttribute('select-first-available'));
          if (!requiresManual && themeWantsAuto) {
            // Ensure one value is selected when theme requests auto-select
            var hasSelected = false;
            for (var k = 0; k < selectEl.options.length; k++) {
              if (selectEl.options[k].selected) { hasSelected = true; break; }
            }
            if (!hasSelected || removedSelected) {
              // Prefer first non-empty option if present
              var idx = 0;
              for (var k2 = 0; k2 < selectEl.options.length; k2++) {
                if (selectEl.options[k2].value !== '') { idx = k2; break; }
              }
              selectEl.selectedIndex = idx;
              try { selectEl.dispatchEvent(new Event('change')); } catch (e) {
                var evt = document.createEvent && document.createEvent('HTMLEvents');
                if (evt) { evt.initEvent('change', true, false); selectEl.dispatchEvent(evt); }
              }
            }
          }
        }
      }
    } catch (e) { /* noop */ }
  }

  // Manage dependent selectors based on first option selection
  function manageDependentSelectors(scope) {
    try {
      var scopeToUse = scope || document;
      var optionsSelections = scopeToUse.querySelectorAll ? scopeToUse.querySelectorAll('options-selection') : [];
      
      // If no options-selection found in scope, try to find them in the document
      if (optionsSelections.length === 0 && scope !== document) {
        optionsSelections = document.querySelectorAll('options-selection');
      }
      
      for (var i = 0; i < optionsSelections.length; i++) {
        var os = optionsSelections[i];
        var selects = os.querySelectorAll('select[data-variant-option]');
        
        if (selects.length === 0) continue;
        
        // Get the first selector
        var firstSelect = null;
        for (var j = 0; j < selects.length; j++) {
          var select = selects[j];
          var optionIndex = parseInt(select.getAttribute('data-variant-option-index'), 10);
          if (isNaN(optionIndex)) optionIndex = j; // fallback to array index
          if (optionIndex === 0) {
            firstSelect = select;
            break;
          }
        }
        
        if (!firstSelect) firstSelect = selects[0]; // fallback to first in DOM order
        if (!firstSelect) continue;
        
        // Bind change listener to first selector if not already bound
        if (!firstSelect.__dependentBound) {
          firstSelect.addEventListener('change', function() {
            setTimeout(function() {
              manageDependentSelectors(scope);
            }, 10);
          });
          firstSelect.__dependentBound = true;
        }
        
        // Also bind change listener to second selector for mounting options
        var secondSelect = null;
        for (var j2 = 0; j2 < selects.length; j2++) {
          var select = selects[j2];
          var optionIndex = parseInt(select.getAttribute('data-variant-option-index'), 10);
          if (isNaN(optionIndex)) optionIndex = j2; // fallback to array index
          if (optionIndex === 1) { // Second option
            secondSelect = select;
            break;
          }
        }
        
        if (secondSelect && !secondSelect.__dependentBound) {
          secondSelect.addEventListener('change', function() {
            setTimeout(function() {
              manageDependentSelectors(scope);
            }, 10);
          });
          secondSelect.__dependentBound = true;
        }
        
        // Check if first selector is set to "not-selected" or empty
        var isFirstNotSelected = !firstSelect.value || 
                                firstSelect.value === '' || 
                                firstSelect.value === 'not-selected';
        
        // Disable/enable second product option selector
        for (var k = 0; k < selects.length; k++) {
          var select = selects[k];
          var optionIndex = parseInt(select.getAttribute('data-variant-option-index'), 10);
          if (isNaN(optionIndex)) optionIndex = k; // fallback to array index
          if (optionIndex === 1) { // Second option
            select.disabled = isFirstNotSelected;
            if (isFirstNotSelected) {
              select.selectedIndex = 0; // Reset to first option
            }
            break;
          }
        }
        
        // Also handle mounting options - disable until both first and second options are selected
        // Look for mounting selectors in the same form or in the entire scope
        var form = os.closest ? os.closest('[data-product-form]') : null;
        var mountingSearchScope = form || scopeToUse;
        if (mountingSearchScope) {
          var mountingSelects = mountingSearchScope.querySelectorAll('.selector-wrapper--mounting select');
          
          // Check if both first and second options are selected
          var firstSelected = firstSelect && firstSelect.value && 
                             firstSelect.value !== '' && 
                             firstSelect.value !== 'not-selected';
          
          var secondSelect = null;
          var secondSelected = false;
          
          // Find the second selector
          for (var s = 0; s < selects.length; s++) {
            var select = selects[s];
            var optionIndex = parseInt(select.getAttribute('data-variant-option-index'), 10);
            if (isNaN(optionIndex)) optionIndex = s; // fallback to array index
            if (optionIndex === 1) { // Second option
              secondSelect = select;
              secondSelected = select.value && 
                              select.value !== '' && 
                              select.value !== 'not-selected';
              break;
            }
          }
          
          // Enable mounting only if both first and second options are selected
          var shouldEnableMount = firstSelected && secondSelected;
          
          for (var m = 0; m < mountingSelects.length; m++) {
            var mountSelect = mountingSelects[m];
            if (mountSelect) {
              mountSelect.disabled = !shouldEnableMount;
              if (!shouldEnableMount) {
                mountSelect.selectedIndex = 0; // Reset to first option
              }
            }
          }
        }
      }
    } catch (e) { /* noop */ }
  }

  // Ensure variant dropdowns start with ATC gating applied
  function ensurePlaceholderOnVariantSelects(form) {
    try {
      if (!form) return;
      var selects = form.querySelectorAll ? form.querySelectorAll('options-selection select[data-variant-option]') : [];
      for (var i = 0; i < selects.length; i++) {
        var s = selects[i];
        // Skip Infinite Options app fields just in case selector overlaps in some themes
        if (s.closest && (s.closest('#infiniteoptions-container') || s.closest('[data-infiniteoptions-container]') || s.closest('[id^="infiniteoptions-"]') || s.closest('.InfiniteOptions'))) {
          continue;
        }
        
        // Only trigger change event if theme wants auto-selection
        if (!s.__placeholderInjected) {
          var formEl = s.closest && s.closest('[data-product-form]');
          var requiresManual = !!(formEl && formEl.getAttribute && formEl.getAttribute('data-require-selection') === 'true');
          var osRoot = s.closest && s.closest('options-selection');
          var themeWantsAuto = !!(osRoot && osRoot.hasAttribute('select-first-available'));
          
          if (!requiresManual && themeWantsAuto) {
            try { s.dispatchEvent(new Event('change')); } catch (e) {
              var evt = document.createEvent && document.createEvent('HTMLEvents');
              if (evt) { evt.initEvent('change', true, false); s.dispatchEvent(evt); }
            }
          }
          s.__placeholderInjected = true;
        }
      }
    } catch (e) { /* noop */ }
  }

  // Toggle price UI to show a selection-required message until options are chosen
  function setPriceGateDisplay(form, needsSelection) {
    try {
      var productRoot = (form.closest && form.closest('[data-section-id]')) || (form.closest && form.closest('[id^="shopify-section-"]')) || (form.closest && form.closest('[class*="product-"]')) || form;
      if (!productRoot || !productRoot.querySelectorAll) return;
      var containers = productRoot.querySelectorAll('[data-price-ui]');
      for (var i = 0; i < containers.length; i++) {
        var el = containers[i];
        if (needsSelection) {
          if (!el.__savedHTML) el.__savedHTML = el.innerHTML;
          el.classList.add('price-ui--selection-required');
          // Prefer to replace data-price node if present; else replace whole content
          var priceNode = el.querySelector('[data-price]');
          var msgHtml = '<span class="price-ui__selection-required">Make A Selection</span>';
          if (priceNode) {
            priceNode.innerHTML = msgHtml;
          } else {
            el.innerHTML = '<div data-price>' + msgHtml + '</div>';
          }
          // Hide compare-at and unit price if present
          var hideNodes = el.querySelectorAll('[data-compare-at-price], [data-unit-price], [data-unit-price-base]');
          for (var h = 0; h < hideNodes.length; h++) {
            hideNodes[h].__prevDisplay = hideNodes[h].style.display;
            hideNodes[h].style.display = 'none';
          }
        } else {
          if (el.__savedHTML) {
            el.innerHTML = el.__savedHTML;
            el.__savedHTML = null;
          }
          el.classList.remove('price-ui--selection-required');
          // Restore hidden nodes
          var hidden = el.querySelectorAll('[data-compare-at-price], [data-unit-price], [data-unit-price-base]');
          for (var r = 0; r < hidden.length; r++) {
            if (typeof hidden[r].__prevDisplay !== 'undefined') {
              hidden[r].style.display = hidden[r].__prevDisplay;
              hidden[r].__prevDisplay = undefined;
            } else {
              hidden[r].style.removeProperty('display');
            }
          }
          // If the theme PriceUI is available and we can get current product/variant, re-render to ensure correct price
          try {
            if (window.PriceUI) {
              var vs = form.__variantSelection || (form.querySelector && form.querySelector(SELECTOR));
              if (vs && typeof vs.getProduct === 'function') {
                Promise.resolve(vs.getProduct()).then(function (product) {
                  var variantP = (typeof vs.getVariant === 'function') ? Promise.resolve(vs.getVariant()) : Promise.resolve(null);
                  return Promise.all([product, variantP]);
                }).then(function (vals) {
                  var product = vals[0];
                  var variant = vals[1];
                  if (!product) return;
                  var ui = new window.PriceUI(el);
                  ui.load(product, { variant: variant, formatter: function (price) {
                    var moneyFormat = (document.body && document.body.getAttribute && document.body.getAttribute('data-money-format')) || (window.Shopify && Shopify.money_format) || '${{amount}}';
                    return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(price, moneyFormat) : price;
                  }, handler: function (frag) { return frag; } });
                }).catch(function () { /* noop */ });
              }
            }
          } catch (e) { /* noop */ }
        }
      }
    } catch (e) { /* noop */ }
  }

  function updateSelectionGateState(form) {
    try {
      var atc = form.querySelector('[name="add"][type="submit"], button[type="submit"][name="add"], [data-add-to-cart], .product-form__add-button, button[type="submit"]');
      if (!atc) return;
      if (!atc.__originalText) atc.__originalText = (atc.textContent || atc.value || '').trim();

      var selects = form.querySelectorAll ? form.querySelectorAll('options-selection select[data-variant-option]') : [];
      var allChosen = true;
      for (var i = 0; i < selects.length; i++) {
        if (selects[i].value === '') { allChosen = false; break; }
      }

      // Toggle price UI message according to selection state
      setPriceGateDisplay(form, !allChosen);

      if (!allChosen) {
        atc.disabled = true;
        if ('value' in atc) atc.value = 'Make A Selection';
        atc.textContent = 'Make A Selection';
        atc.classList.add('is-disabled');
      } else {
        atc.disabled = false;
        var label = atc.__originalText || 'Add to cart';
        if ('value' in atc) atc.value = label;
        atc.textContent = label;
        atc.classList.remove('is-disabled');
      }
    } catch (e) { /* noop */ }
  }

  function setupSelectionGate(form, vs) {
    try {
      if (!form || form.__selectionGateSetup) return;
      form.setAttribute('data-require-selection', 'true');
      form.__variantSelection = vs || (form.querySelector && form.querySelector(SELECTOR));

      // Do not insert a separate title; integrate message into price UI instead

      // Ensure placeholders on initial load for variant dropdowns
      ensurePlaceholderOnVariantSelects(form);

      // Disable ATC until valid and adjust price UI
      updateSelectionGateState(form);

      // Listen to option changes and variant changes to update state
      var os = form.querySelector('options-selection');
      if (os && !os.__gateBound) {
        os.addEventListener('change', function () { updateSelectionGateState(form); });
        os.__gateBound = true;
      }
      if (form.__variantSelection && !form.__variantSelection.__gateVariantBound) {
        form.__variantSelection.addEventListener('variant-change', function () { updateSelectionGateState(form); });
        form.__variantSelection.__gateVariantBound = true;
      }

      // Also watch for dynamically added selects
      if (!form.__gateMo) {
        try {
          form.__gateMo = new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
              var m = mutations[i];
              if (m.addedNodes && m.addedNodes.length) {
                for (var j = 0; j < m.addedNodes.length; j++) {
                  var node = m.addedNodes[j];
                  if (node && node.nodeType === 1) {
                    if (node.matches && node.matches('options-selection select[data-variant-option]')) {
                      ensurePlaceholderOnVariantSelects(form);
                      updateSelectionGateState(form);
                    } else if (node.querySelector) {
                      if (node.querySelector('options-selection select[data-variant-option]')) {
                        ensurePlaceholderOnVariantSelects(form);
                        updateSelectionGateState(form);
                      }
                    }
                  }
                }
              }
            }
          });
          form.__gateMo.observe(form, { childList: true, subtree: true });
        } catch (e) { /* noop */ }
      }

      form.__selectionGateSetup = true;
    } catch (e) { /* noop */ }
  }

  // Default no-op; override with window.CustomVariantHooks.setCallback
  var onVariantReadyFn = function (detail, el) {
    // detail: { product, variant, state, ... }, el: <variant-selection>
    try {
      if (this && typeof this.addMountingOptions === 'function') {
        this.addMountingOptions(detail || {}, el || null);
      }
    } catch (e) { /* noop */ }
  };

  function fire(el, detail) {
    try {
      var ctx = (typeof window !== 'undefined' && window.CustomVariantHooks) ? window.CustomVariantHooks : (typeof window !== 'undefined' ? window : null);
      if (ctx && typeof onVariantReadyFn === 'function') {
        onVariantReadyFn.call(ctx, detail || {}, el);
      } else {
        onVariantReadyFn(detail || {}, el);
      }
      // Also emit a global event consumers can listen for elsewhere
      document.dispatchEvent(new CustomEvent('custom:variant-ready', {
        detail: { el: el, product: detail && detail.product, variant: detail && detail.variant, state: detail && detail.state }
      }));
    } catch (e) {
      // Fail-safe: never break the product page
    }
  }

  // New: robustly keep Infinite Options below variant-selection
  function findNearestVariantSelectionFor(container) {
    if (!container || !container.ownerDocument) return null;
    var doc = container.ownerDocument;

    // 1) Same product form if possible
    var formScope = container.closest && container.closest('[data-product-form]');
    if (formScope && formScope.querySelector) {
      var vsInForm = formScope.querySelector('variant-selection');
      if (vsInForm) return vsInForm;
    }

    // 2) Same section wrapper
    var section = container.closest && (container.closest('[data-section-id]') || container.closest('section'));
    if (section && section.querySelector) {
      var vsInSection = section.querySelector('variant-selection');
      if (vsInSection) return vsInSection;
    }

    // 3) Fallback: nearest preceding variant-selection in document order
    var all = doc.querySelectorAll('variant-selection');
    var chosen = null;
    for (var i = 0; i < all.length; i++) {
      var v = all[i];
      if (v.compareDocumentPosition && (v.compareDocumentPosition(container) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        chosen = v; // keep updating to get the last preceding
      }
    }
    return chosen || all[0] || null;
  }

  //  Helper to find the closest mounting wrapper to a given container
  function findMountingWrapperFor(container) {
    if (!container || !container.ownerDocument) return null;

    // 1) Same product form if possible
    var formScope = container.closest && container.closest('[data-product-form]');
    if (formScope && formScope.querySelector) {
      var wInForm = formScope.querySelector('.selector-wrapper--mounting');
      if (wInForm) return wInForm;
    }

    // 2) Same section wrapper
    var section = container.closest && (container.closest('[data-section-id]') || container.closest('section'));
    if (section && section.querySelector) {
      var wInSection = section.querySelector('.selector-wrapper--mounting');
      if (wInSection) return wInSection;
    }

    // 3) Fallback: nearest preceding mounting wrapper in document order
    var all = container.ownerDocument.querySelectorAll('.selector-wrapper--mounting');
    var chosen = null;
    for (var i = 0; i < all.length; i++) {
      var w = all[i];
      if (w.compareDocumentPosition && (w.compareDocumentPosition(container) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        chosen = w; // keep updating to get the last preceding
      }
    }
    return chosen || null;
  }

  //  Move helpers for Infinite Options
  function tryMoveInfiniteOptions(container) {
    // Prefer placing below mounting options (if present)
    var mount = findMountingWrapperFor(container);
    if (mount && mount.parentNode) {
      if (mount.nextElementSibling !== container) {
        mount.parentNode.insertBefore(container, mount.nextElementSibling);
      }
      return true;
    }

    // Fallback: below variant-selection
    var vs = findNearestVariantSelectionFor(container);
    if (vs && vs.parentNode) {
      if (vs.nextElementSibling !== container) {
        vs.parentNode.insertBefore(container, vs.nextElementSibling);
      }
      return true;
    }
    return false;
  }

  function scheduleMoveInfiniteOptions(container, maxAttempts, delayMs) {
    var attempts = 0;
    var max = typeof maxAttempts === 'number' ? maxAttempts : 20;
    var delay = typeof delayMs === 'number' ? delayMs : 50;
    function tick() {
      if (!container || !container.parentNode) return; // removed from DOM
      if (tryMoveInfiniteOptions(container)) return;
      if (attempts++ < max) setTimeout(tick, delay);
    }
    tick();
  }

  function repositionInfiniteOptions(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll ? scope.querySelectorAll('#infiniteoptions-container') : [];
    for (var i = 0; i < containers.length; i++) {
      tryMoveInfiniteOptions(containers[i]);
    }
  }

  function handleVariantChange(e) {
    fire(e.currentTarget, e.detail || {});
    try {
      var formRoot = e.currentTarget && e.currentTarget.closest ? e.currentTarget.closest('[data-product-form]') : null;
      repositionInfiniteOptions(formRoot || document);
      // Also prune unavailable options on each variant update
      pruneUnavailableOptions(formRoot || document);
    } catch (err) {}
  }

  function initEl(el) {
    if (!el || el.getAttribute(BOUND_ATTR)) return;
    try {
      el.addEventListener('variant-change', handleVariantChange);
      el.setAttribute(BOUND_ATTR, 'true');

      // Ensure options UI hides/removes unavailable choices
      configureOptionsSelectionFor(el);

      // If the element already loaded and we missed the first event, try to synthesize one
      try {
        if (typeof el.getProduct === 'function') {
          Promise.resolve(el.getProduct())
            .then(function (product) {
              var variantP = (typeof el.getVariant === 'function') ? Promise.resolve(el.getVariant()) : Promise.resolve(null);
              var stateP = (typeof el.getState === 'function') ? Promise.resolve(el.getState()) : Promise.resolve(el.getAttribute('variant'));
              return Promise.all([product, variantP, stateP]);
            })
            .then(function (vals) {
              fire(el, { product: vals[0], variant: vals[1], state: vals[2] });
            })
            .catch(function () { /* noop */ });
        }
        // If no helper methods exist, rely on the next variant-change that the component emits
      } catch (e) { /* noop */ }
    } catch (e) { /* noop */ }
  }

  function scan(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
    for (var i = 0; i < nodes.length; i++) initEl(nodes[i]);
  }

  // Watch for dynamic additions (featured product, quickshop, section renders)
  try {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (node && node.nodeType === 1) {
              // On first insert, try now and also retry shortly after to catch late variant-selection renders
              if (node.id === 'infiniteoptions-container') {
                scheduleMoveInfiniteOptions(node);
              } else if (node.querySelector) {
                var ios = node.querySelectorAll('#infiniteoptions-container');
                if (ios && ios.length) {
                  for (var k = 0; k < ios.length; k++) scheduleMoveInfiniteOptions(ios[k]);
                }
              }

              // If new options-selection were added, configure and prune
              if (node.tagName && node.tagName.toLowerCase() === 'options-selection') {
                configureOptionsSelectionFor(node.closest('variant-selection') || node);
                manageDependentSelectors(node.closest('variant-selection') || document);
              } else if (node.querySelector) {
                var osEls = node.querySelectorAll('options-selection');
                if (osEls && osEls.length) {
                  for (var z = 0; z < osEls.length; z++) configureOptionsSelectionFor(osEls[z].closest('variant-selection') || osEls[z]);
                  manageDependentSelectors(node);
                }
              }

              if (node.matches && node.matches(SELECTOR)) initEl(node);
              else if (node.querySelector) scan(node);
            }
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  // Shopify Theme Editor lifecycle
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
    repositionInfiniteOptions(e.target);
    manageDependentSelectors(e.target);
    var ios = e.target.querySelectorAll ? e.target.querySelectorAll('#infiniteoptions-container') : [];
    for (var i = 0; i < ios.length; i++) scheduleMoveInfiniteOptions(ios[i]);

    // Also apply unavailable hiding for any variant selections in this section
    var vsEls = e.target.querySelectorAll ? e.target.querySelectorAll(SELECTOR) : [];
    for (var j = 0; j < vsEls.length; j++) configureOptionsSelectionFor(vsEls[j]);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
      repositionInfiniteOptions();
      manageDependentSelectors(document);
      var ios = document.querySelectorAll('#infiniteoptions-container');
      for (var i = 0; i < ios.length; i++) scheduleMoveInfiniteOptions(ios[i]);
    });
  } else {
    scan();
    repositionInfiniteOptions();
    manageDependentSelectors(document);
    var iosNow = document.querySelectorAll('#infiniteoptions-container');
    for (var i = 0; i < iosNow.length; i++) scheduleMoveInfiniteOptions(iosNow[i]);
  }

  // Helper: find a variant object by its ID in a product JSON
  function getVariantById(prod, id) {
    id = String(id);
    if (!prod || !Array.isArray(prod.variants)) return null;
    for (var i = 0; i < prod.variants.length; i++) {
      var v = prod.variants[i];
      if (String(v.id) === id) return v;
    }
    return null;
  }

  // MultipleProducts support helpers (optional, no-op if not configured)
  var __MP_CACHE = {};
  function parseRelatedHandlesFromTags(tags) {
    var handles = [];
    if (!tags) return handles;
    var list = Array.isArray(tags) ? tags : String(tags).split(',');
    for (var i = 0; i < list.length; i++) {
      var t = String(list[i]).trim();
      var m = t.match(/^MultipleProducts[:\-]\s*(.+)$/i);
      if (m && m[1]) {
        var parts = m[1].split(/[|,; ]+/);
        for (var j = 0; j < parts.length; j++) {
          var h = String(parts[j]).trim();
          if (h) handles.push(h);
        }
      }
    }
    return handles;
  }
  function fetchProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (__MP_CACHE[handle]) return __MP_CACHE[handle];
    __MP_CACHE[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return __MP_CACHE[handle];
  }
  function ensureMergedProduct(baseProduct, form) {
    try {
      var hasFlag = (form && form.getAttribute && form.getAttribute('data-has-multiple-product') === 'true');
      var handles = parseRelatedHandlesFromTags(baseProduct && baseProduct.tags);
      var attr = form && form.getAttribute ? form.getAttribute('data-multiple-products-handles') : null;
      if (attr) {
        attr.split(/[|,; ]+/).forEach(function (s) { var h = s && String(s).trim(); if (h) handles.push(h); });
      }
      // Dedup
      var seen = {};
      handles = handles.filter(function (h) { if (!h || seen[h]) return false; seen[h] = 1; return true; });
      if (!hasFlag && (!handles || !handles.length)) return Promise.resolve(baseProduct);
      if (!handles.length) return Promise.resolve(baseProduct);
      return Promise.all(handles.map(fetchProductByHandle)).then(function (others) {
        var merged = Object.assign({}, baseProduct);
        merged.variants = Array.prototype.slice.call(baseProduct.variants || []);
        for (var i = 0; i < others.length; i++) {
          var p = others[i];
          if (p && Array.isArray(p.variants)) merged.variants = merged.variants.concat(p.variants);
        }
        return merged;
      });
    } catch (e) {
      return Promise.resolve(baseProduct);
    }
  }

  // Utility: allow disabling cart redirect for debugging (via flag or URL ?cvh_noredirect=1)
  function __cvhIsRedirectDisabled() {
    try {
      if (window.__CVH_DISABLE_REDIRECT === true) return true;
      var s = (window.location && (window.location.search + window.location.hash)) || '';
      return /(^|[?#&])cvh_noredirect=1(&|$)/.test(s);
    } catch (e) { return false; }
  }
  function maybeRedirectToCart() {
    try { if (__cvhIsRedirectDisabled()) return; window.location.assign('/cart'); } catch (e) {}
  }

  // Helper: install global interceptor to append mounting item after theme add
   var __CVH_FETCH_INSTALLED = false;
  function installAddToCartInterceptor() {
    if (__CVH_FETCH_INSTALLED) return;
    try {
      function parseAddPayload(obj) {
        var info = { mainId: null, mainQty: 1, isMountingPayload: false };
        if (!obj) return info;
        if (obj.items && Array.isArray(obj.items) && obj.items.length) {
          for (var i = 0; i < obj.items.length; i++) {
            var it = obj.items[i] || {};
            var props = it.properties || {};
            var looksMount = Object.prototype.hasOwnProperty.call(props, 'Belongs To') || Object.prototype.hasOwnProperty.call(props, 'Belongs To Key');
            if (!looksMount) { info.mainId = String(it.id); info.mainQty = it.quantity || 1; break; }
          }
        } else if (obj.id) {
          info.mainId = String(obj.id);
          info.mainQty = obj.quantity || 1;
          var props2 = obj.properties || {};
          if (Object.prototype.hasOwnProperty.call(props2, 'Belongs To') || Object.prototype.hasOwnProperty.call(props2, 'Belongs To Key')) info.isMountingPayload = true;
        }
        return info;
      }
      function parseAddBody(body) {
        var info = { mainId: null, mainQty: 1, isMountingPayload: false };
        if (!body) return info;
        try {
          if (typeof body === 'string') {
            var s = body.trim();
            if (s.charAt(0) === '{' || s.indexOf('items') > -1) {
              return parseAddPayload(JSON.parse(s));
            }
            var params = new URLSearchParams(body);
            var idStr = params.get('id');
            var qtyStr = params.get('quantity');
            if (idStr) info.mainId = String(idStr);
            if (qtyStr) info.mainQty = parseInt(qtyStr, 10) || 1;
            params.forEach(function(_, k){ if (/^properties\[(Belongs To|Belongs To Key)\]$/.test(k)) info.isMountingPayload = true; });
            return info;
          }
          if (body instanceof FormData) {
            var fd = body;
            var idFD = fd.get('id');
            var qtyFD = fd.get('quantity');
            if (idFD) info.mainId = String(idFD);
            if (qtyFD) info.mainQty = parseInt(qtyFD, 10) || 1;
            var keys = fd.keys ? Array.from(fd.keys()) : [];
            for (var i2 = 0; i2 < keys.length; i2++) {
              if (/^properties\[(Belongs To|Belongs To Key)\]$/.test(keys[i2])) { info.isMountingPayload = true; break; }
            }
            return info;
          }
          if (typeof body.get === 'function') {
            var idQS = body.get('id');
            var qtyQS = body.get('quantity');
            if (idQS) info.mainId = String(idQS);
            if (qtyQS) info.mainQty = parseInt(qtyQS, 10) || 1;
          }
        } catch (e) { /* noop */ }
        return info;
      }
      async function appendMountingAfterMain(mainId, mainQty, mainLineKey) {
        try {
          // Skip if we're in custom mounting processing mode
          if (window._cvh_processing_custom_mount) {
            return;
          }
          
          if (!mainId) return;
          // Prefer marked form
          var form = document.querySelector('[data-product-form][data-cvh-wants-mount="true"]');
          if (!form) {
            var idInputs = document.querySelectorAll('[data-product-form] [name="id"]');
            for (var ii = 0; ii < idInputs.length; ii++) {
              var inp = idInputs[ii];
              if (String(inp.value) === String(mainId)) { form = inp.closest('[data-product-form]'); break; }
            }
          }
          if (!form || form.getAttribute('data-has-mounting') !== 'true') return;
          var select = form.querySelector('.selector-wrapper--mounting select');
          var qtyEl = form.querySelector('[name="quantity"]');
          var qtyAttr = form.getAttribute('data-cvh-mount-qty');
          var qty = qtyAttr ? (parseInt(qtyAttr, 10) || mainQty || 1) : (qtyEl ? (parseInt(qtyEl.value, 10) || mainQty || 1) : (mainQty || 1));
          var mountIdAttr = form.getAttribute('data-cvh-mount-id');
          var mountId = mountIdAttr || (select && select.value) || '';
          if (!mountId) return;
          var title = (function(){ try { var p = form.getAttribute('data-product') || null; return p ? (JSON.parse(p).title || '') : (window.product && window.product.title) || ''; } catch(e){ return (window.product && window.product.title) || ''; } })();
          try {
            var addInit = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              credentials: 'same-origin',
              keepalive: true,
              body: JSON.stringify({ items: [ { id: Number(mountId), quantity: qty, properties: { 'Belongs To': title, 'Belongs To Key': mainLineKey || '' } } ] })
            };
            if (typeof fetch === 'function') {
              await fetch('/cart/add.js', addInit);
            }
          } catch (e2) { /* noop */ }
          try {
            form.removeAttribute('data-cvh-wants-mount');
            form.removeAttribute('data-cvh-mount-id');
            form.removeAttribute('data-cvh-mount-qty');
          } catch (e3) {}
          maybeRedirectToCart();
        } catch (e) { /* noop */ }
      }

      // Wrap fetch
      if (window.fetch && !window.fetch.__cvh_wrapped) {
        var originalFetch = window.fetch;
        var wrappedFetch = async function(input, init) {
          var reqUrl = (typeof input === 'string') ? input : (input && input.url);
          var method = (init && init.method) ? String(init.method).toUpperCase() : 'GET';
          var isAdd = reqUrl && /\/cart\/add\.js(\?|$)/.test(reqUrl) && method === 'POST';

          var mainId = null, mainQty = 1, isMountingPayload = false;
          if (isAdd) {
            var parsed = null;
            try { if (init && typeof init.body === 'string') parsed = JSON.parse(init.body); } catch (e) {}
            if (parsed) {
              var infoParsed = parseAddPayload(parsed);
              mainId = infoParsed.mainId; mainQty = infoParsed.mainQty; isMountingPayload = infoParsed.isMountingPayload;
            } else {
              var info = parseAddBody(init && init.body);
              mainId = info.mainId; mainQty = info.mainQty; isMountingPayload = info.isMountingPayload;
            }
          }
          var res = await originalFetch.apply(this, arguments);
          var mainLineKey = null;
          try {
            if (isAdd && res && res.ok) {
              var data = await res.clone().json();
              if (data) {
                if (Array.isArray(data.items) && data.items.length) {
                  var foundKey = null;
                  for (var di = 0; di < data.items.length; di++) {
                    var dIt = data.items[di];
                    var propsD = dIt && dIt.properties || {};
                    var looksMountD = propsD && (Object.prototype.hasOwnProperty.call(propsD, 'Belongs To') || Object.prototype.hasOwnProperty.call(propsD, 'Belongs To Key'));
                    if (!looksMountD && dIt && dIt.key) { foundKey = dIt.key; break; }
                  }
                  mainLineKey = foundKey || (data.items[0] && data.items[0].key) || null;
                } else if (data && typeof data === 'object') {
                  mainLineKey = data.key || null;
                }
              }
            }
          } catch (e) { /* noop */ }
          try {
            if (isAdd && res && res.ok && mainId && !isMountingPayload) {
              await appendMountingAfterMain(mainId, mainQty, mainLineKey);
            }
          } catch (e) { /* noop */ }
          return res;
        };
        wrappedFetch.__cvh_wrapped = true;
        window.fetch = wrappedFetch;
      }

      // Wrap XMLHttpRequest to catch jQuery/vanilla XHR adds
      if (window.XMLHttpRequest && !window.XMLHttpRequest.__cvh_wrapped) {
        var XHR = window.XMLHttpRequest;
        var origOpen = XHR.prototype.open;
        var origSend = XHR.prototype.send;
        XHR.prototype.open = function(method, url) { try { this.__cvhMethod = method; this.__cvhURL = url; } catch (e) {} return origOpen.apply(this, arguments); };
        XHR.prototype.send = function(body) {
          var isAdd = this.__cvhURL && /\/cart\/add\.js(\?|$)/.test(this.__cvhURL) && String(this.__cvhMethod || '').toUpperCase() === 'POST';
          var info = parseAddBody(body);
          var mainId = info.mainId, mainQty = info.mainQty, isMountingPayload = info.isMountingPayload;
          this.addEventListener('loadend', function() {
            try {
              if (!isAdd || this.status < 200 || this.status >= 300 || !mainId || isMountingPayload) return;
              var mainKey = null;
              try {
                var txt = this.responseText;
                if (txt) {
                  var d = JSON.parse(txt);
                  if (Array.isArray(d && d.items) && d.items.length) {
                    var found = null;
                    for (var di = 0; di < d.items.length; di++) {
                      var itD = d.items[di];
                      var propsD = itD && itD.properties || {};
                      var looksMountD = propsD && (Object.prototype.hasOwnProperty.call(propsD, 'Belongs To') || Object.prototype.hasOwnProperty.call(propsD, 'Belongs To Key'));
                      if (!looksMountD && itD && itD.key) { found = itD.key; break; }
                    }
                    mainKey = found || (d.items[0] && d.items[0].key) || null;
                  } else if (d && typeof d === 'object') {
                    mainKey = d.key || null;
                  }
                }
              } catch (e) { /* noop */ }
              appendMountingAfterMain(mainId, mainQty, mainKey);
            } catch (e) { /* noop */ }
          });
          return origSend.apply(this, arguments);
        };
        window.XMLHttpRequest.__cvh_wrapped = true;
      }

      __CVH_FETCH_INSTALLED = true;
      window.__CVH_FETCH_INSTALLED = true;
    } catch (e) { /* noop */ }
  }

  // Install the interceptor globally on script load so it's available site-wide
  try { installAddToCartInterceptor(); } catch (e) { /* noop */ }

  // Function to fix temp keys on cart pages
  function fixTempKeysOnCart() {
    try {
      // Only run on cart pages
      if (!window.location.pathname.includes('/cart')) return;
      
      // Safety: Prevent infinite reload loops
      var reloadCount = parseInt(sessionStorage.getItem('cvh_reload_count') || '0', 10);
      if (reloadCount >= 3) {
        console.warn('CVH: Too many reloads detected, clearing localStorage and stopping');
        try { localStorage.removeItem('frameUpdates'); } catch (e) {}
        try { sessionStorage.removeItem('cvh_reload_count'); } catch (e) {}
        return;
      }
      
      var frameUpdates = [];
      try { frameUpdates = JSON.parse(localStorage.getItem('frameUpdates') || '[]'); } catch (e) { frameUpdates = []; }

      // Get current cart (always fetch; we may need to ensure base has Mounting Option even if no temp keys)
      fetch('/cart.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to fetch cart');
        return response.json();
      })
      .then(function(cartData) {
        if (!cartData || !cartData.items) return;

        // Helpers
        function isMountingItem(it) {
          var p = it && it.properties || {};
          return Object.prototype.hasOwnProperty.call(p, 'Belongs To') || Object.prototype.hasOwnProperty.call(p, 'Belongs To Key');
        }
        function mergeProps(a, b) {
          var out = {};
          a = a || {}; b = b || {};
          for (var k in a) { if (Object.prototype.hasOwnProperty.call(a, k) && a[k] != null) out[k] = a[k]; }
          for (var k2 in b) { if (Object.prototype.hasOwnProperty.call(b, k2)) out[k2] = b[k2]; }
          return out;
        }

        var items = cartData.items;
        var baseByKey = {};
        var baseByTitle = {};
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (!isMountingItem(it)) {
            baseByKey[it.key] = it;
            var t = it.product_title;
            if (t) {
              if (!baseByTitle[t]) baseByTitle[t] = [];
              baseByTitle[t].push(it);
            }
          }
        }

  // 1) Ensure base item has Mounting Option property
        var basePropRequests = [];
        var baseUpdates = {};
        for (var i3 = 0; i3 < items.length; i3++) {
          var frame2 = items[i3];
          if (!isMountingItem(frame2)) continue;
          var fProps2 = frame2.properties || {};
          var baseKey = fProps2['Belongs To Key'];
          var baseItem = null;
          if (baseKey && String(baseKey).indexOf('temp-key-') !== 0) {
            baseItem = baseByKey[baseKey] || null;
          }
          if (!baseItem) {
            var title2 = fProps2['Belongs To'];
            if (title2 && baseByTitle[title2] && baseByTitle[title2].length) baseItem = baseByTitle[title2][0];
          }
          if (!baseItem) continue;

          var mountTitle = frame2.variant_title || frame2.title || '';
          var baseProps = baseItem.properties || {};
          if (mountTitle && baseProps['Mounting Option'] !== mountTitle) {
            // Stage a merged update per base key (dedup multiple frames)
            var existing = baseUpdates[baseItem.key];
            var merged = mergeProps(baseProps, { 'Mounting Option': mountTitle });
            baseUpdates[baseItem.key] = { id: baseItem.key, properties: merged };
          }
        }

        Object.keys(baseUpdates).forEach(function(k) {
          var upd = baseUpdates[k];
          basePropRequests.push(fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: upd.id, properties: upd.properties })
          }));
        });

        // Execute base property updates first, then reconcile frame keys (including temp-key and stale-key cases)
        return Promise.all(basePropRequests).then(function(resBase) {
          // After potential base updates (which can change base keys), re-fetch cart to get fresh keys
          return fetch('/cart.js', { method: 'GET', headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
            .then(function(r){ return r.ok ? r.json() : cartData; })
            .then(function(freshCart){
              var fresh = freshCart && freshCart.items ? freshCart.items : items;
              // Rebuild base maps
              var freshBaseByKey = {};
              var freshBaseByTitle = {};
              for (var fb = 0; fb < fresh.length; fb++) {
                var itB = fresh[fb];
                if (!isMountingItem(itB)) {
                  freshBaseByKey[itB.key] = itB;
                  var tB = itB.product_title;
                  if (tB) { if (!freshBaseByTitle[tB]) freshBaseByTitle[tB] = []; freshBaseByTitle[tB].push(itB); }
                }
              }

              // Build frame fix list: temp-key frames OR frames whose Belongs To Key no longer matches any base key
              var frameFixRequests = [];
              var orphanRemovalRequests = [];
              var successfulTempKeys = {};
              var framesNeedingFix = [];
              for (var fi = 0; fi < fresh.length; fi++) {
                var fr = fresh[fi];
                if (!isMountingItem(fr)) continue;
                var fp = fr.properties || {};
                var frTitle = fp['Belongs To'] || '';
                var targetBase = (frTitle && freshBaseByTitle[frTitle] && freshBaseByTitle[frTitle][0]) || null;
                if (!targetBase) {
                  // Orphan: no base found by title; remove this mounting line
                  orphanRemovalRequests.push(fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    credentials: 'same-origin',
                    body: JSON.stringify({ id: fr.key, quantity: 0 })
                  }));
                  continue;
                }
                var currentBTK = fp['Belongs To Key'];
                var needsFix = false;
                if (!currentBTK) needsFix = true;
                else if (String(currentBTK).indexOf('temp-key-') === 0) needsFix = true;
                else if (!freshBaseByKey[currentBTK]) needsFix = true; // stale key after base key changed
                if (needsFix) {
                  framesNeedingFix.push({ frame: fr, main: targetBase, tempKey: (String(currentBTK || '').indexOf('temp-key-') === 0) ? currentBTK : null });
                  frameFixRequests.push(fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    credentials: 'same-origin',
                    body: JSON.stringify({ id: fr.key, properties: mergeProps(fp, { 'Belongs To': targetBase.product_title, 'Belongs To Key': targetBase.key }) })
                  }));
                }
              }

              return Promise.all(frameFixRequests.concat(orphanRemovalRequests)).then(function(resFrames){
                var anyOk = false;
                for (var b = 0; b < (resBase || []).length; b++) { if (resBase[b] && resBase[b].ok) { anyOk = true; break; } }
                if (!anyOk) {
                  for (var c = 0; c < (resFrames || []).length; c++) { if (resFrames[c] && resFrames[c].ok) { anyOk = true; break; } }
                }

                // Clean up processed temp keys in localStorage
                if (frameUpdates && frameUpdates.length && framesNeedingFix.length) {
                  for (var ix = 0; ix < (resFrames || []).length; ix++) {
                    if (resFrames[ix] && resFrames[ix].ok && framesNeedingFix[ix] && framesNeedingFix[ix].tempKey) {
                      successfulTempKeys[framesNeedingFix[ix].tempKey] = true;
                    }
                  }
                  if (Object.keys(successfulTempKeys).length) {
                    try {
                      var remain = frameUpdates.filter(function(u){ return !successfulTempKeys[u && u.tempKey]; });
                      localStorage.setItem('frameUpdates', JSON.stringify(remain));
                    } catch (e) { /* noop */ }
                  }
                }

                if (anyOk) { 
                  // Increment reload counter for safety
                  try { sessionStorage.setItem('cvh_reload_count', String(reloadCount + 1)); } catch (e) {}
                  try { window.location.reload(); } catch (e) {} 
                }
              });
            });
        });
      })
      .catch(function(error) {
        console.error('Error fixing temp keys:', error);
      });
      
    } catch (e) {
      console.error('Error in fixTempKeysOnCart:', e);
    }
  }

  // Run temp key fix when page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixTempKeysOnCart);
  } else {
    fixTempKeysOnCart();
  }

  // Expose for manual testing - ensure it's available globally
  // Run temp key fix when page loads
  if (window.location.pathname.includes('/cart')) {
    document.addEventListener('DOMContentLoaded', fixTempKeysOnCart);
    fixTempKeysOnCart();
  }

  // Minimal public API for swapping in custom logic later
  window.CustomVariantHooks = {
    addMountingOptions: function (detail, el) {
      try {
        var mountProduct = window.mountProduct;
        if (!mountProduct || !Array.isArray(mountProduct.variants) || !mountProduct.variants.length) return;

        var product = (detail && detail.product) || window.product || null;
        var variant = (detail && detail.variant) || null;
        var form = (el && el.closest && el.closest('[data-product-form]')) || document.querySelector('[data-product-form]');
        if (!form || !product) return;

        // Ensure interceptor is installed (fetch and XHR)
        installAddToCartInterceptor();

        // Mark form as having mounting and set up selection gate (placeholders, title, disabled ATC)
        form.setAttribute('data-has-mounting', 'true');
        setupSelectionGate(form, el || (form.querySelector && form.querySelector('variant-selection')));

        // Merge MultipleProducts first, then render/build
        ensureMergedProduct(product, form).then(function (mergedProduct) {
          product = mergedProduct || product;

          // Place wrapper just after the variant-selection in this form
          var vs = el || (form.querySelector && form.querySelector('variant-selection'));
          var idSuffix = (product && product.id) ? String(product.id) : 'x';
          var wrapperId = 'mounting-wrapper-' + idSuffix;
          var selectId = 'mounting-' + idSuffix;
          var wrapper = form.querySelector('#' + wrapperId);
          if (!wrapper) {
            wrapper = document.createElement('div');
            wrapper.className = 'selector-wrapper selector-wrapper--mounting';
            wrapper.id = wrapperId;

            var label = document.createElement('label');
            label.htmlFor = selectId;
            var labelText = 'Mounting';
            var tags = product && product.tags;
            var hasMagnetTag = false;
            if (Array.isArray(tags)) hasMagnetTag = tags.indexOf('Magnetic Number Prop') > -1;
            else if (typeof tags === 'string') hasMagnetTag = tags.indexOf('Magnetic Number Prop') > -1;
            if (hasMagnetTag) labelText = 'Extra Magnets';
            label.textContent = labelText;

            var span = document.createElement('span');
            span.className = 'select';

            var select = document.createElement('select');
            select.className = 'single-option-selector';
            select.id = selectId;

            span.appendChild(select);
            wrapper.appendChild(label);
            wrapper.appendChild(span);

            if (vs && vs.parentNode) vs.parentNode.insertBefore(wrapper, vs.nextElementSibling);
            else form.appendChild(wrapper);

            // Apply dependent selectors management after mounting UI is inserted
            manageDependentSelectors(form);

            // After inserting mounting UI, ensure Infinite Options is moved below it
            try {
              repositionInfiniteOptions(form);
              var iosInForm = form.querySelectorAll ? form.querySelectorAll('#infiniteoptions-container') : [];
              for (var m = 0; m < iosInForm.length; m++) scheduleMoveInfiniteOptions(iosInForm[m]);
            } catch (e) { /* noop */ }

            // Custom function to add frame first, then process normal cart
            window.AddFrameToCartBeforeProcessing = async function() {
              try {
                // Set a flag to prevent normal mounting processing
                window._cvh_processing_custom_mount = true;
                
                var sel = form.querySelector('#' + selectId);
                if (!sel || !sel.value) {
                  // No mounting option selected, just trigger normal add to cart
                  window._cvh_processing_custom_mount = false;
                  var originalBtn = form.querySelector('[type="submit"][name="add"], [data-add-to-cart-trigger], [data-add-to-cart]');
                  if (originalBtn) originalBtn.click();
                  return;
                }

                var mountingId = sel.value;
                var qtyEl = form.querySelector('[name="quantity"]');
                var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
                var productTitle = (product && product.title) || '';
                var tempKey = 'temp-key-' + Date.now();
                var frameLineKey = null;

                // Step 1: Add the mounting option (frame) to cart first
                try {
                  var frameResponse = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({
                      items: [{
                        id: Number(mountingId),
                        quantity: qty,
                        properties: {
                          'Belongs To': productTitle,
                          'Belongs To Key': tempKey
                        }
                      }]
                    })
                  });
                  
                  if (!frameResponse.ok) {
                    throw new Error('Failed to add frame to cart');
                  }
                  
                  var frameData = await frameResponse.json();
                  // Get the frame's line key for later update
                  if (frameData && frameData.key) {
                    frameLineKey = frameData.key;
                  } else if (frameData && frameData.items && frameData.items.length > 0) {
                    frameLineKey = frameData.items[0].key;
                  }
                } catch (frameError) {
                  console.error('Error adding frame:', frameError);
                  // If frame fails, still try to add main product
                }

                // Step 2: Now trigger the original add-to-cart button to handle main product and add-ons
                var originalBtn = form.querySelector('[type="submit"][name="add"], [data-add-to-cart-trigger], [data-add-to-cart]');
                if (originalBtn) {
                  // Clear mounting selection flags to avoid double processing
                  form.removeAttribute('data-cvh-wants-mount');
                  form.removeAttribute('data-cvh-mount-id');
                  form.removeAttribute('data-cvh-mount-qty');
                  
                  // ALSO temporarily clear the mounting selector value to prevent normal processing
                  var sel = form.querySelector('#' + selectId);
                  var originalMountingValue = sel ? sel.value : '';
                  if (sel) {
                    sel.value = ''; // Clear to prevent normal mounting processing
                  }
                  
                  // Add property to main product to show which mounting option was selected
                  var mountProduct = window.mountProduct;
                  var selectedMountTitle = '';
                  if (mountProduct && Array.isArray(mountProduct.variants)) {
                    for (var i = 0; i < mountProduct.variants.length; i++) {
                      if (String(mountProduct.variants[i].id) === String(mountingId)) {
                        selectedMountTitle = mountProduct.variants[i].title;
                        break;
                      }
                    }
                  }
                  
                  // Try to add mounting option property to form if possible
                  if (selectedMountTitle) {
                    var hiddenInput = form.querySelector('input[name="properties[Mounting Option]"]');
                    if (!hiddenInput) {
                      hiddenInput = document.createElement('input');
                      hiddenInput.type = 'hidden';
                      hiddenInput.name = 'properties[Mounting Option]';
                      form.appendChild(hiddenInput);
                    }
                    hiddenInput.value = selectedMountTitle;
                  }
                  
                  // Store frame info for later update on cart page
                  if (frameLineKey && tempKey) {
                    // Store in localStorage so cart page can fix the keys
                    try {
                      var frameUpdates = JSON.parse(localStorage.getItem('frameUpdates') || '[]');
                      frameUpdates.push({
                        tempKey: tempKey,
                        frameLineKey: frameLineKey,
                        productTitle: productTitle,
                        timestamp: Date.now()
                      });
                      localStorage.setItem('frameUpdates', JSON.stringify(frameUpdates));
                    } catch (e) {
                      console.error('Error storing frame update info:', e);
                    }
                  } else {
                    // Missing frame info for storage
                  }
                  
                  // Trigger the original button
                  originalBtn.click();
                  
                  // Add cart redirect since normal processing might be skipped
                  setTimeout(function() {
                    // Check if we're still on the product page after a short delay
                    if (window.location.pathname.includes('/products/')) {
                      window.location.href = '/cart';
                    }
                  }, 1500); // Give time for normal cart processing to happen first
                }
              } catch (error) {
                console.error('Error in AddFrameToCartBeforeProcessing:', error);
                // Fallback: trigger original button anyway
                var originalBtn = form.querySelector('[type="submit"][name="add"], [data-add-to-cart-trigger], [data-add-to-cart]');
                if (originalBtn) originalBtn.click();
              } finally {
                // Always clear the flag
                setTimeout(function() {
                  window._cvh_processing_custom_mount = false;
                }, 1000);
              }
            };

            // Function to toggle button visibility based on mounting selection
            function toggleAddToCartButtons(forceShowOriginal) {
              var sel = form.querySelector('#' + selectId);
              var originalBtn = form.querySelector('[type="submit"][name="add"], [data-add-to-cart-trigger], [data-add-to-cart]');
              var customBtn = form.querySelector('[data-custom-frame-cart]');
              
              if (!originalBtn) return;
              
              var hasMountingSelection = sel && sel.value && sel.value !== '';
              
              if (forceShowOriginal || !hasMountingSelection) {
                // Show original button, hide custom button
                originalBtn.style.display = '';
                if (customBtn) {
                  customBtn.style.display = 'none';
                }
              } else if (hasMountingSelection) {
                // Hide original button, show custom button
                originalBtn.style.display = 'none';
                
                if (!customBtn) {
                  // Create custom button
                  customBtn = originalBtn.cloneNode(true);
                  customBtn.setAttribute('data-custom-frame-cart', 'true');
                  customBtn.removeAttribute('name');
                  customBtn.removeAttribute('type');
                  customBtn.type = 'button';
                  customBtn.onclick = function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    window.AddFrameToCartBeforeProcessing();
                  };
                  
                  // Change button text to match original (keep it the same)
                  // The button will look identical to the original
                  
                  // Insert custom button after original
                  originalBtn.parentNode.insertBefore(customBtn, originalBtn.nextSibling);
                }
                customBtn.style.display = '';
              }
            }

            // Listen for mounting selection changes
            select.addEventListener('change', function() {
              toggleAddToCartButtons();
              // Price calculation removed - let Shopify handle pricing
            });

            // Initial button state setup
            setTimeout(function() {
              toggleAddToCartButtons();
            }, 100);

            // Remove the old submit handler since we're using the button approach
            // Submit handler (once per form) using two-step add to capture Belongs To Key
            /* OLD SUBMIT HANDLER REMOVED - REPLACED WITH BUTTON APPROACH */
          }

          // (Re)populate options based on current variant and optional mapping
          var selectEl = wrapper.querySelector('select');
          if (!selectEl.__baseOptions) {
            var base = [];
            mountProduct.variants.forEach(function (v) {
              if (!v.available) return;
              var opt = document.createElement('option');
              opt.value = String(v.id);
              
              // Format the price and add it to the option text
              var priceText = '';
              if (typeof v.price === 'number' && window.Shopify && typeof Shopify.formatMoney === 'function') {
                var moneyFormat = (document.body && document.body.getAttribute && document.body.getAttribute('data-money-format')) || Shopify.money_format;
                priceText = ' +' + Shopify.formatMoney(v.price, moneyFormat);
              }
              opt.textContent = v.title + priceText;
              
              opt.setAttribute('data-sku', v.sku || '');
              opt.setAttribute('data-value', v.title);
              base.push(opt);
            });
            selectEl.__baseOptions = base;
          }

          // Preserve selection if possible
          var prevVal = selectEl.value;
          while (selectEl.firstChild) selectEl.removeChild(selectEl.firstChild);
          
          // Add default empty option first
          var defaultOpt = document.createElement('option');
          defaultOpt.value = '';
          defaultOpt.textContent = 'Choose an option';
          selectEl.appendChild(defaultOpt);
          
          var mapObj = window.mountProductOption || null;
          var key = variant ? [variant.option1, variant.option2].filter(Boolean).join(' - ') : null;
          selectEl.__baseOptions.forEach(function (opt) {
            var include = true;
            if (mapObj && key) {
              var title = opt.getAttribute('data-value');
              var m = mapObj[title];
              include = !!(m && m.options && m.options[key]);
            }
            if (include) selectEl.appendChild(opt.cloneNode(true));
          });

          // Restore previous selection if it still exists
          if (prevVal) {
            selectEl.value = prevVal;
          }
          
          // Update ATC state in case variant gets reset by mapping
          updateSelectionGateState(form);
          
          // Apply dependent selectors management after mounting options are populated
          manageDependentSelectors(form);

        }).catch(function () { /* noop */ });

      } catch (e) { /* noop */ }
    },
    setCallback: function (fn) {
      if (typeof fn === 'function') onVariantReadyFn = fn;
    },
    fixTempKeysOnCart: fixTempKeysOnCart
  };
})();

// Simple global function for testing temp key fixes
window.debugFixTempKeys = function() {
  try {
    console.log('debugFixTempKeys called');
    
    // First, let's see ALL localStorage contents
    console.log('All localStorage contents:');
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      const value = localStorage.getItem(key);
      console.log(`  ${key}: ${value}`);
    }
    
    // Only run on cart pages
    if (!window.location.pathname.includes('/cart')) {
      console.log('Not on cart page');
      return;
    }
    
    var frameUpdates = JSON.parse(localStorage.getItem('frameUpdates') || '[]');
    console.log('Frame updates from localStorage:', frameUpdates);
    
    if (frameUpdates.length === 0) {
      console.log('No frame updates found - this means either no frames were added or they were already processed');
      return;
    }
    
    console.log('Fetching current cart...');
    
    // Get current cart
    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
    .then(function(response) {
      console.log('Cart response:', response);
      if (!response.ok) throw new Error('Failed to fetch cart');
      return response.json();
    })
    .then(function(cartData) {
      console.log('Cart data:', cartData);
      
      if (!cartData || !cartData.items) {
        console.log('No cart items found');
        return;
      }
      
      var updatesNeeded = [];
      
      // Find items that need updating
      for (var i = 0; i < cartData.items.length; i++) {
        var item = cartData.items[i];
        var props = item.properties || {};
        
        // Check if this item has a temp key that needs fixing
        var belongsToKey = props['Belongs To Key'];
        console.log('Item', i, 'Belongs To Key:', belongsToKey);
        
        if (belongsToKey && belongsToKey.startsWith('temp-key-')) {
          console.log('Found temp key item:', item);
          
          // Find the corresponding frame update info
          for (var j = 0; j < frameUpdates.length; j++) {
            var updateInfo = frameUpdates[j];
            if (updateInfo.tempKey === belongsToKey) {
              console.log('Found matching update info:', updateInfo);
              
              // Find the main product for this frame
              var mainProductKey = null;
              for (var k = 0; k < cartData.items.length; k++) {
                var mainItem = cartData.items[k];
                var mainProps = mainItem.properties || {};
                var hasLongBelongsTo = Object.prototype.hasOwnProperty.call(mainProps, 'Belongs To') || Object.prototype.hasOwnProperty.call(mainProps, 'Belongs To Key');
                
                console.log('Checking item', k, 'for main product:', mainItem.product_title, 'hasLongBelongsTo:', hasLongBelongsTo);
                
                if (!hasLongBelongsTo && mainItem.product_title === updateInfo.productTitle) {
                  mainProductKey = mainItem.key;
                  console.log('Found main product key:', mainProductKey);
                  break;
                }
              }
              
              if (mainProductKey) {
                updatesNeeded.push({
                  frameKey: item.key,
                  mainKey: mainProductKey,
                  productTitle: updateInfo.productTitle,
                  tempKey: belongsToKey
                });
              }
              break;
            }
          }
        }
      }
      
      console.log('Updates needed:', updatesNeeded);
      
      if (updatesNeeded.length === 0) {
        console.log('No updates needed');
        return;
      }
      
      // Process first update as test
      var update = updatesNeeded[0];
      console.log('Processing update:', update);
      
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: update.frameKey,
          properties: {
            'Belongs To': update.productTitle,
            'Belongs To Key': update.mainKey
          }
        })
      });
    })
    .then(function(response) {
      if (response) {
        console.log('Update response:', response);
        if (response.ok) {
          console.log('Update successful!');
          window.location.reload();
        } else {
          console.log('Update failed');
        }
      }
    })
    .catch(function(error) {
      console.error('Error in debugFixTempKeys:', error);
    });
    
  } catch (e) {
    console.error('Error in debugFixTempKeys:', e);
  }
};


